import React, { useEffect, useState } from 'react'
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js'
import { Dialog } from '@headlessui/react'
import './layout.css'

const isBrowser = typeof window !== 'undefined'

export default function CheckoutForm({ isOpen, setIsOpen, title, text, price }) {
  const stripe = useStripe()
  const elements = useElements()
  const [email, setEmail] = useState('')
  const [errorEmail, setErrorEmail] = useState('')
  const [message, setMessage] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!stripe) {
      return
    }

    const clientSecret = isBrowser
      ? new URLSearchParams(window.location.search).get('payment_intent_client_secret')
      : null

    if (!clientSecret) {
      return
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case 'succeeded':
          setMessage('Payment succeeded!')
          break
        case 'processing':
          setMessage('Your payment is processing.')
          break
        case 'requires_payment_method':
          setMessage('Your payment was not successful, please try again.')
          break
        default:
          setMessage('Something went wrong.')
          break
      }
    })
  }, [stripe])

  function isValidEmail(mail) {
    return /\S+@\S+\.\S+/.test(mail)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!stripe || !elements) return

    if (!email) {
      setErrorEmail(`Merci d'indiquer votre adresse mail.`)
      return
    } else if (!isValidEmail(email)) {
      setErrorEmail(`L'adresse mail est invalide.`)
      return
    }

    setIsLoading(true)

    const response = await stripe.confirmPayment({
      elements,
      confirmParams: {
        //TODO switch url with env
        //return_url: 'https://deploy-preview-4--sleeping-baby.netlify.app/order-fulfilled',
        //return_url: 'https://localhost:8888/order-fulfilled/',
        return_url: 'https://www.bebeaupaysdusommeil.com/order-fulfilled/',
        receipt_email: email,
      },
    })
    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (response.error.type === 'card_error' || response.error.type === 'validation_error') {
      setMessage(response.error.message)
    } else {
      setMessage('An unexpected error occurred.')
    }

    setIsLoading(false)
  }

  return (
    <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-50">
      <div className="fixed inset-0 bg-black opacity-75 w-full" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4 bg-black/30 overflow-y-scroll">
        <Dialog.Panel className="max-w-lg m-auto bg-salmony-0 rounded-md border-2 border-purple-600">
          <div className="bg-purple-600 px-4 pt-6 pb-4 overflow-hidden rounded-sm">
            <Dialog.Title className="text-salmony-0 font-bold">{title}</Dialog.Title>
            <Dialog.Description className="font-muli text-white pb-4">{text}</Dialog.Description>
            <Dialog.Description className="font-muli text-white pb-4 text-center font-bold">
              Total : {price}
            </Dialog.Description>
          </div>

          <form id="payment-form" onSubmit={handleSubmit} className="px-4 pt-2 pb-6">
            <section className="flex flex-col font-sans text-custom-grey text-base">
              <label htmlFor="email" className="pb-1 font-bold">
                Votre adresse email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value)
                  setErrorEmail('')
                }}
                placeholder="Adresse email"
                className="email-input p-2 border border-custom-cream rounded shadow-sm"
                required
              />
              {errorEmail && <p className="text-red-600 mt-1">{errorEmail}</p>}
            </section>
            <PaymentElement id="payment-element" className="mb-16 mt-4" />
            <button disabled={isLoading || !stripe || !elements} id="submit">
              <span
                className={`${isLoading ? '' : 'bg-purple-600'} text-white font-bold px-3 py-2 rounded-lg`}
                id="button-text"
              >
                {isLoading ? <div className="lds-dual-ring"></div> : 'Payer'}
              </span>
            </button>
            {/* Show any error or success messages */}
            {message && <div className="pt-6 text-purple-600">{message}</div>}
          </form>
        </Dialog.Panel>
      </div>
    </Dialog>
  )
}
